// @flow
import { FormattedCurrency } from "../../../../../../components/FormattedCurrency/FormattedCurrency";

export * from "../data";

export const currencyFormatter = (value: string | number) => (
  <FormattedCurrency
    value={value}
    minimumFractionDigits={2}
    maximumFractionDigits={2}
    currency="USD"
  />
);

// Data hard coded for now. Should come from backend.
export const rows = [
  {
    location_html: <span>Durban, South Africa</span>,
    days_on_market: null,
    cost: 94342.9,
    rental: 565.31,
    airbnb: 5300.56,
  },
  {
    location_html: <span>Lagos, Nigeria</span>,
    days_on_market: null,
    cost: 132490.22,
    rental: 1001.4,
    airbnb: 6009.89,
  },
  {
    location_html: <span>Cairo, Egypt</span>,
    days_on_market: null,
    cost: 60293.4,
    rental: 387.29,
    airbnb: 2623.82,
  },
  {
    location_html: (
      <span>
        Reykjavik, Iceland
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 418662.57,
    rental: 2202.76,
    airbnb: 12832.64,
  },
  {
    location_html: <span>Johannesburg, South Africa</span>,
    days_on_market: null,
    cost: 158370.28,
    rental: 878.5,
    airbnb: 4754.12,
  },
  {
    location_html: <span>Santiago, Chile</span>,
    days_on_market: null,
    cost: 187448.36,
    rental: 849.4,
    airbnb: 5516.63,
  },
  {
    location_html: <span>Athens, Greece</span>,
    days_on_market: null,
    cost: 207240.35,
    rental: 536.65,
    airbnb: 4909.06,
  },
  {
    location_html: <span>Bangalore, India</span>,
    days_on_market: null,
    cost: 113716.48,
    rental: 425.3,
    airbnb: 2496.57,
  },
  {
    location_html: <span>Dubai, UAE</span>,
    days_on_market: null,
    cost: 725012.74,
    rental: 3872.76,
    airbnb: 15891.76,
  },
  {
    location_html: <span>Bucharest, Romania</span>,
    days_on_market: null,
    cost: 168585.97,
    rental: 641.84,
    airbnb: 3672.33,
  },
  {
    location_html: <span>Medellin, Colombia</span>,
    days_on_market: null,
    cost: 176130.59,
    rental: 520.68,
    airbnb: 3562.1,
  },
  {
    location_html: <span>Cape Town, South Africa</span>,
    days_on_market: null,
    cost: 253274.87,
    rental: 1234.45,
    airbnb: 5076.44,
  },
  {
    location_html: <span>Budapest, Hungary</span>,
    days_on_market: null,
    cost: 186230.26,
    rental: 767.07,
    airbnb: 3500.12,
  },
  {
    location_html: <span>Istanbul, Turkey</span>,
    days_on_market: null,
    cost: 220255.04,
    rental: 951.85,
    airbnb: 3919.47,
  },
  {
    location_html: <span>Washington D.C., USA</span>,
    days_on_market: null,
    cost: 798257.53,
    rental: 3648.13,
    airbnb: 12468.1,
  },
  {
    location_html: <span>Delhi, India</span>,
    days_on_market: null,
    cost: 177263.52,
    rental: 527.89,
    airbnb: 2715.77,
  },
  {
    location_html: <span>Dusseldorf, Germany</span>,
    days_on_market: null,
    cost: 596943.27,
    rental: 1610.33,
    airbnb: 8716.26,
  },
  {
    location_html: <span>Sofia, Bulgaria</span>,
    days_on_market: null,
    cost: 151493.98,
    rental: 628.47,
    airbnb: 2192.78,
  },
  {
    location_html: <span>Frankfurt am Main, Germany</span>,
    days_on_market: null,
    cost: 701022.86,
    rental: 1741.26,
    airbnb: 9853.17,
  },
  {
    location_html: <span>Montreal, Canada</span>,
    days_on_market: null,
    cost: 354370.85,
    rental: 1296.38,
    airbnb: 4816.35,
  },
  {
    location_html: <span>Bogota, Colombia</span>,
    days_on_market: null,
    cost: 234629.67,
    rental: 694.21,
    airbnb: 3118.61,
  },
  {
    location_html: <span>Buenos Aires, Argentina</span>,
    days_on_market: null,
    cost: 267783.1,
    rental: 959.95,
    airbnb: 3520.19,
  },
  {
    location_html: <span>Sydney, Australia</span>,
    days_on_market: null,
    cost: 1013552.08,
    rental: 3212.95,
    airbnb: 12645.9,
  },
  {
    location_html: <span>Dublin, Ireland</span>,
    days_on_market: null,
    cost: 630169.58,
    rental: 2134.67,
    airbnb: 7520.94,
  },
  {
    location_html: <span>Perth, Australia</span>,
    days_on_market: null,
    cost: 561637.66,
    rental: 1966.38,
    airbnb: 6623.81,
  },
  {
    location_html: (
      <span>
        Hamburg, Germany
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 608087.22,
    rental: 1522.61,
    airbnb: 7141.97,
  },
  {
    location_html: <span>Jakarta, Indonesia</span>,
    days_on_market: null,
    cost: 202406.97,
    rental: 1305.84,
    airbnb: 2374.9,
  },
  {
    location_html: (
      <span>
        Amsterdam, Netherlands
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 827309.4,
    rental: 2482.08,
    airbnb: 9489.95,
  },
  {
    location_html: <span>Riga, Latvia</span>,
    days_on_market: null,
    cost: 209971.1,
    rental: 669.0,
    airbnb: 2331.47,
  },
  {
    location_html: <span>Munich, Germany</span>,
    days_on_market: null,
    cost: 886599.7,
    rental: 1937.47,
    airbnb: 9843.26,
  },
  {
    location_html: <span>Edinburgh, UK</span>,
    days_on_market: null,
    cost: 390084.31,
    rental: 1631.37,
    airbnb: 4200.91,
  },
  {
    location_html: <span>Sao Paulo, Brazil</span>,
    days_on_market: null,
    cost: 297511.93,
    rental: 1065.43,
    airbnb: 3188.46,
  },
  {
    location_html: <span>Mexico City, Mexico</span>,
    days_on_market: null,
    cost: 238718.47,
    rental: 860.26,
    airbnb: 2480.56,
  },
  {
    location_html: <span>Prague, Czech Republic</span>,
    days_on_market: null,
    cost: 344152.47,
    rental: 1052.84,
    airbnb: 3556.0,
  },
  {
    location_html: (
      <span>
        Barcelona, Spain
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 460002.51,
    rental: 1304.59,
    airbnb: 4651.5,
  },
  {
    location_html: <span>Warsaw, Poland</span>,
    days_on_market: null,
    cost: 263899.57,
    rental: 910.25,
    airbnb: 2662.68,
  },
  {
    location_html: <span>Brussels, Belgium</span>,
    days_on_market: null,
    cost: 375979.7,
    rental: 1505.36,
    airbnb: 3635.5,
  },
  {
    location_html: <span>Rio de Janeiro, Brazil</span>,
    days_on_market: null,
    cost: 369173.07,
    rental: 1300.73,
    airbnb: 3536.44,
  },
  {
    location_html: (
      <span>
        Berlin, Germany
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 502784.14,
    rental: 1372.66,
    airbnb: 4791.46,
  },
  {
    location_html: <span>Geneva, Switzerland</span>,
    days_on_market: null,
    cost: 1334392.89,
    rental: 3386.15,
    airbnb: 12520.17,
  },
  {
    location_html: <span>Auckland, New Zealand</span>,
    days_on_market: null,
    cost: 783668.38,
    rental: 2061.96,
    airbnb: 7252.21,
  },
  {
    location_html: <span>Copenhagen, Denmark</span>,
    days_on_market: null,
    cost: 680068.48,
    rental: 2590.54,
    airbnb: 6071.36,
  },
  {
    location_html: <span>Melbourne, Australia</span>,
    days_on_market: null,
    cost: 696134.33,
    rental: 2309.01,
    airbnb: 5962.65,
  },
  {
    location_html: <span>Kuala Lumpur, Malaysia</span>,
    days_on_market: null,
    cost: 195864.14,
    rental: 900.48,
    airbnb: 1664.21,
  },
  {
    location_html: <span>Zurich, Switzerland</span>,
    days_on_market: null,
    cost: 1349293.28,
    rental: 3198.67,
    airbnb: 11125.71,
  },
  {
    location_html: <span>Los Angeles, USA</span>,
    days_on_market: null,
    cost: 873352.33,
    rental: 3142.74,
    airbnb: 7137.15,
  },
  {
    location_html: <span>Stockholm, Sweden</span>,
    days_on_market: null,
    cost: 933178.91,
    rental: 2194.33,
    airbnb: 7522.21,
  },
  {
    location_html: <span>Hanoi, Vietnam</span>,
    days_on_market: null,
    cost: 267633.26,
    rental: 847.61,
    airbnb: 2125.98,
  },
  {
    location_html: <span>Chicago, USA</span>,
    days_on_market: null,
    cost: 471462.1,
    rental: 2732.94,
    airbnb: 3738.63,
  },
  {
    location_html: <span>Osaka, Japan</span>,
    days_on_market: null,
    cost: 470247.54,
    rental: 1306.9,
    airbnb: 3715.77,
  },
  {
    location_html: <span>Oslo, Norway</span>,
    days_on_market: null,
    cost: 740393.9,
    rental: 2208.12,
    airbnb: 5777.23,
  },
  {
    location_html: <span>Toronto, Canada</span>,
    days_on_market: null,
    cost: 615737.08,
    rental: 2072.76,
    airbnb: 4576.83,
  },
  {
    location_html: <span>Miami, USA</span>,
    days_on_market: null,
    cost: 972895.53,
    rental: 3114.67,
    airbnb: 7104.89,
  },
  {
    location_html: <span>Madrid, Spain</span>,
    days_on_market: null,
    cost: 594285.91,
    rental: 1528.96,
    airbnb: 4294.89,
  },
  {
    location_html: <span>Bangkok, Thailand</span>,
    days_on_market: null,
    cost: 365611.77,
    rental: 1247.75,
    airbnb: 2589.53,
  },
  {
    location_html: <span>Vienna, Austria</span>,
    days_on_market: null,
    cost: 642803.9,
    rental: 1508.98,
    airbnb: 4457.19,
  },
  {
    location_html: <span>Brisbane, Australia</span>,
    days_on_market: null,
    cost: 536833.52,
    rental: 2046.88,
    airbnb: 3628.39,
  },
  {
    location_html: <span>Lisbon, Portugal</span>,
    days_on_market: null,
    cost: 490621.78,
    rental: 1136.69,
    airbnb: 3307.33,
  },
  {
    location_html: <span>Tel Aviv, Israel</span>,
    days_on_market: null,
    cost: 1164108.46,
    rental: 1842.54,
    airbnb: 7372.1,
  },
  {
    location_html: <span>Helsinki, Finland</span>,
    days_on_market: null,
    cost: 767769.11,
    rental: 2022.0,
    airbnb: 4393.95,
  },
  {
    location_html: <span>Milan, Italy</span>,
    days_on_market: null,
    cost: 943537.43,
    rental: 1905.6,
    airbnb: 5399.02,
  },
  {
    location_html: <span>Singapore, Singapore</span>,
    days_on_market: null,
    cost: 1486939.59,
    rental: 3662.62,
    airbnb: 8368.54,
  },
  {
    location_html: <span>Moscow, Russia</span>,
    days_on_market: null,
    cost: 639343.77,
    rental: 1472.93,
    airbnb: 3597.66,
  },
  {
    location_html: (
      <span>
        New York City, USA
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 1650602.66,
    rental: 5211.22,
    airbnb: 9112.0,
  },
  {
    location_html: (
      <span>
        London, UK
        <sup>6</sup>
      </span>
    ),
    days_on_market: null,
    cost: 2149931.92,
    rental: 5361.83,
    airbnb: 11194.2,
  },
  {
    location_html: (
      <span>
        San Francisco, USA
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 1426323.03,
    rental: 5437.22,
    airbnb: 6996.94,
  },
  {
    location_html: <span>Shanghai, China</span>,
    days_on_market: null,
    cost: 1125062.15,
    rental: 1927.03,
    airbnb: 5471.41,
  },
  {
    location_html: <span>Vancouver, Canada</span>,
    days_on_market: null,
    cost: 865343.84,
    rental: 2540.2,
    airbnb: 4036.57,
  },
  {
    location_html: (
      <span>
        Paris, France
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 1216772.36,
    rental: 2404.71,
    airbnb: 5634.48,
  },
  {
    location_html: <span>Rome, Italy</span>,
    days_on_market: null,
    cost: 990976.54,
    rental: 1847.06,
    airbnb: 4537.71,
  },
  {
    location_html: <span>Seoul, South Korea</span>,
    days_on_market: null,
    cost: 1056345.76,
    rental: 2077.51,
    airbnb: 4607.56,
  },
  {
    location_html: <span>Tokyo, Japan</span>,
    days_on_market: null,
    cost: 1541999.07,
    rental: 2564.89,
    airbnb: 5848.86,
  },
  {
    location_html: <span>Taipei, Taiwan</span>,
    days_on_market: null,
    cost: 1044932.99,
    rental: 1508.39,
    airbnb: 3854.7,
  },
  {
    location_html: <span>Hong Kong, Hong Kong</span>,
    days_on_market: null,
    cost: 2404789.37,
    rental: 4208.23,
    airbnb: 5273.55,
  },
  {
    location_html: <span>Beijing, China</span>,
    days_on_market: null,
    cost: 1344933.57,
    rental: 2006.15,
    airbnb: 1883.16,
  },
];
